// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
import { provideJupyterDesignSystem, jpTreeView } from '@jupyter/web-components';
import { provideReactWrapper } from '@microsoft/fast-react-wrapper';
import React from 'react';
const { wrap } = provideReactWrapper(React, provideJupyterDesignSystem());
export const TreeView = wrap(jpTreeView());
// @ts-expect-error unknown property
TreeView.displayName = 'Jupyter.TreeView';
